import {Injectable} from "@angular/core";
import {ComIncludeInScheduledRebalanceDialogComponent} from "@irb/irb-editors/editor-portfolio/com-include-in-scheduled-rebalance-dialog/com-include-in-scheduled-rebalance-dialog.component";

@Injectable({
    providedIn: "root"
})
export class ComIncludeInScheduledRebalanceDialogGridLayoutService {
    getFrameworkComponents() {}
    constructor() {
    }

    getColumnDefs(parent: ComIncludeInScheduledRebalanceDialogComponent) {
        const columns: any = [
            {
                headerName: 'Select All',
                colId: 'selectAllSchedRebal',
                headerComponent: 'customHeader',
                cellRenderer: 'customHeader',
                cellRendererParams: {parentObject: parent, type: 'rowCheckBox'},
                suppressColumnsToolPanel: true,
                suppressFiltersToolPanel: true,
                suppressSizeToFit: true,
                toolPanelClass: 'toolpanel-header-checkbox-hide',
                headerComponentParams: {parentObject: parent, type: 'headerCheckBox'},
                floatingFilterComponent: 'customHeader',
                floatingFilterComponentParams: {parentObject: parent, type: 'clearAllBtn'},
                suppressFloatingFilterButton: true,
                pinned: 'left',
                suppressMovable: true,
                lockPosition: true,
                lockVisible: true,
                sorting: false,
                filter: true,
                resizable: true,
                minWidth: 25,
                width: 25,
                maxWidth:25,
                cellStyle: {'padding': '5px 3px 0 2px'},
                headerClass: 'customHeaderClassSelectAll',
                cellClass: 'selectAllCheckBoxRecord'
            },

            {
                headerName: "Rebalances",
                suppressMovable: true,
                lockPosition: true,
                lockVisible: true,
                children: [
                    {
                        headerName: "Rebalance Name",
                        field: "analysisName",
                        colId: "analysisName",
                        filter: "agTextColumnFilter",
                        suppressFloatingFilterButton: true,
                        suppressFiltersToolPanel: true,
                        lockPosition: true,
                        lockVisible: true,
                        suppressMovable: true,
                        cellRenderer: "cellRendererFormatter"
                    },
                    {
                        headerName: "Type",
                        field: "analysisType",
                        colId: "analysisType",
                        suppressMovable: true,
                        cellRendererSelector: this.showRebalanceType.bind(this),
                        filter: "agSetColumnFilter",
                        filterParams: {
                            buttons: ["reset", "apply"],
                            values: (params: any) => {
                                params.success(parent.scheduledTypeList);
                            },
                            newRowsAction: "keep",
                            suppressSorting: true,
                            cellHeight: 30,
                            closeOnApply: true
                        },
                        suppressFiltersToolPanel: true,
                    },
                    {
                        headerName: "Frequency",
                        field: "schedulerFrequency",
                        colId: "schedulerFrequency",
                        suppressMovable: true,
                        cellRenderer: "cellRendererFormatter"
                    }
                ],
            },
            {
                headerName: "Schedule Details",
                children: [
                    {
                        headerName: "Qty",
                        field: "portQty",
                        colId: "portQty",
                        suppressMovable: true,
                        cellRenderer: "cellRendererFormatter",
                        cellRendererParams: {type: "currency", displaySymbol: " "}
                    },
                    {
                        headerName: "Next",
                        field: "nextRunDate",
                        sort: 'desc',
                        colId: "nextRunDate",
                        cellRenderer: "cellRendererFormatter",
                        suppressMovable: true,
                        cellRendererParams: {type: "date", format: "MM/dd/yyyy", convertWithNoDisplayETtext: true}
                    }
                ],
            },
            {
                headerName: 'Scheduled By',
                suppressColumnsToolPanel: true,
                suppressFiltersToolPanel: false,
                colId: 'analysisCreatedBy',
                field: 'analysisCreatedBy',
                hide: true,
                filter: 'agSetColumnFilter',
                filterParams:   {
                    values: (params: any) => {
                        params.success(parent.scheduledOwnerList);
                    },
                    buttons:['reset', 'apply'],
                    newRowsAction: 'keep',
                    suppressSorting: true,
                    cellHeight: 30,
                    closeOnApply: true,
                    refreshValuesOnOpen: true
                },
            },
            {
                headerName: "Contains Portfolio",
                suppressColumnsToolPanel: true,
                field: "portfolioName",
                colId: "portfolioName",
                hide: true,
                filter: "agTextColumnFilter",
                suppressFloatingFilterButton: true,
                filterParams: {
                    filterOptions: ['contains'],
                    clearButton: false,
                    debounceMs: 1000,
                    textFormatter: this.textFilterFormatter,
                    maxNumConditions: 1,
                }
            }
        ];
        return columns;
    }
    private textFilterFormatter(r: any) {
        if (r == null) { return null; }

        return r;
    }

    showRebalanceType(params: any) {
        let rebalanceType = params.data.analysisType;
        // if (rebalanceType === "Fully rebalance securities & cash")
        //     rebalanceType = 'Full rebalance';
        return {
            component: "cellRendererFormatter",
            params: { value:  rebalanceType},
        }
    }

}
